/** Same-origin proxy to 2.0 /api/wls/{organization_id}/… */

export function wlsApiRoot(organizationId) {
  return `/api/wls/${organizationId}`;
}

export function wlsApiHeaders() {
  return { 'Content-Type': 'application/json' };
}
